import React from 'react';
import type { PathTranslations } from 'service/localization/getPathTranslations';
import type { DictionaryItem } from 'service/dictionary/dictionaryService';

export const GlobalContext = React.createContext<{
  themeName?: string;
  pathTranslations: PathTranslations;
  userToken: string;
  globalDictionary: DictionaryItem[];
}>({
  themeName: '',
  pathTranslations: {} as PathTranslations,
  userToken: '',
  globalDictionary: [],
});

export const GlobalContextProvider = GlobalContext.Provider;
export const GlobalContextConsumer = GlobalContext.Consumer;
